import type { ReactNode } from 'react';

export const Kbd = ({ children }: { children: ReactNode }) => (
  <span
    style={{
      fontFamily: 'var(--font-mono)',
      fontSize: 10,
      padding: '2px 6px',
      background: 'var(--surface-3)',
      borderRadius: 4,
    }}
  >
    {children}
  </span>
);
